import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { CommonUiModule, IS_PROD_ENV } from 'common-ui';
import { TrackingPageComponent } from './pages/tracking-page/tracking-page.component';
import { AppRoutingModule } from './app-routing.module';
import { ApiModule, Configuration } from '@evermile/customer-tracking';
import {
  ApiModule as CommunicationApiModule,
  Configuration as CommunicationConfiguration,
} from '@evermile/communications-external';
import { AuthService } from './services/auth.service';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as Sentry from '@sentry/angular-ivy';
import { Router } from '@angular/router';
import { UnsubscribePageComponent } from './pages/unsubscribe-page/unsubscribe-page.component';
import { MatNativeDateModule } from '@angular/material/core';

@NgModule({
  declarations: [AppComponent, TrackingPageComponent, UnsubscribePageComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    CommonUiModule,
    ApiModule,
    CommunicationApiModule,
    MatNativeDateModule,
  ],
  providers: [
    {
      provide: Configuration,
      useFactory: (authService: AuthService) =>
        new Configuration({
          basePath: environment.endpoint + '/customer-tracking',
          credentials: {
            bearerAuth: authService.getIdToken.bind(authService),
          },
        }),
      deps: [AuthService],
      multi: false,
    },
    {
      provide: CommunicationConfiguration,
      useFactory: (authService: AuthService) =>
        new CommunicationConfiguration({
          basePath: environment.endpoint + '/communications-external',
          credentials: {
            bearerAuth: authService.getIdToken.bind(authService),
          },
        }),
      deps: [AuthService],
      multi: false,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {
        // no factory needed
      },
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: IS_PROD_ENV,
      useValue: environment.production,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
